export default __webpack_public_path__ + "static/media/logo2000x2000.0c44f415.png";